import React, { createContext, useContext, useState, useEffect } from 'react';

const ProjectContext = createContext(null);

export function ProjectProvider({ children }) {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [selectedCamera, setSelectedCamera] = useState(null);

  // Save to localStorage
  useEffect(() => {
    if (selectedProject) {
      localStorage.setItem('selectedProject', JSON.stringify(selectedProject));
    }
  }, [selectedProject]);

  // Load from localStorage on mount
  useEffect(() => {
    const saved = localStorage.getItem('selectedProject');
    if (saved) {
      try {
        setSelectedProject(JSON.parse(saved));
      } catch (error) {
        console.error('Error loading saved project:', error);
      }
    }
  }, []);

  const selectProject = (project) => {
    setSelectedProject(project);
    setSelectedSite(null);
    setSelectedCamera(null);
  };

  const selectSite = (site) => {
    setSelectedSite(site);
    setSelectedCamera(null);
  };

  const selectCamera = (camera) => {
    setSelectedCamera(camera);
  };

  const clearSelection = () => {
    setSelectedProject(null);
    setSelectedSite(null);
    setSelectedCamera(null);
    localStorage.removeItem('selectedProject');
  };

  const value = {
    selectedProject,
    selectedSite,
    selectedCamera,
    selectProject,
    selectSite,
    selectCamera,
    clearSelection,
  };

  return <ProjectContext.Provider value={value}>{children}</ProjectContext.Provider>;
}

export function useProject() {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProject must be used within ProjectProvider');
  }
  return context;
}
